import { Component, Vue, Watch } from 'vue-property-decorator';
import { getAuthToken } from '@/utils/cookies';

import { OfflineResMgr } from '@/api/index';

@Component
export default class OfflineResourceMgr extends Vue {
  // 搜索项
  private searchOption: any = {
    isOpenMore: false, // 是否展开更多
    pid: '', // 板卡型号
    serialNumber: '', // 序列号
    deviceType: '', // 设备型号
    classifyValue: '', // 硬件类型
    statusValue: '', // 硬件状态
    vprovinceValue: '', // 省份
    manufacturerValue: '', // 厂商
  };
  private dicts: any = {}; // 字典表
  private vprovinceOption: object[] = []; // 省份
  private offlineResTableData: object[] =  []; // 表格数据
  private selectedTableDataIds: string = ''; // 选中的表格数据
  // 设置表格columns
  private columns: object[] = [
    { prop: 'deviceType', title: '设备型号' },
    { prop: 'pid', title: '板卡型号' },
    {
      prop: 'serialNumber',
      title: '序列号',
      type: 'link',
      routerParams(item) {return { name: 'offlineResDetail', params: { id: item.id } };  }
    },
    { prop: 'deviceName', title: '来源设备名称' },
    { prop: 'classifyName', title: '硬件归类' },
    { prop: 'statusName', title: '备件状态' },
    { prop: 'provinceName', title: '所属省份' },
    { prop: 'propertyCardNumber', title: '所属厂商' }
  ];
  // 分页
  private page: any = {
    currPage: 1,
    size: 10,
    total: 0,
    sizes: [10, 20, 50, 100],
    layout: 'total, sizes, prev, pager, next, jumper'
  };
  // 初始化
  private created() {
    this.getDicts();
    this.getVprovinceOption();
    this.getOfflineResTableData();
  }
  // 搜索
   private searchClick() {
    this.getOfflineResTableData();
  }
  // 获取字典表
  private getDicts() {
    const array = [
      { label: '备件类型', id: 'classify' },
      { label: '备件状态', id: 'resource_status_offline' },
      { label: '所属厂商', id: 'manufacturer'}
    ];
    for (const item of array) {
      OfflineResMgr.getDicts(item.id).then(dict => {
        this.$set(this.dicts, item.id, dict.data);
        this.dicts[item.id].unshift(
          {
            displayName: `全部${item.label}`,
            value: ''
          }
        );
      });
    }
  }
  // 获取省份
  private getVprovinceOption() {
    OfflineResMgr.getVprovinceList('', '').then(res => {
      this.vprovinceOption = res.data;
      this.vprovinceOption.unshift(
        {
          vProvinceName: '全部省份',
          id: ''
        }
      );
    });
  }
  // 展开更多/关闭更多按钮Click
  private openMoreBtnClick() {
    this.searchOption.isOpenMore = !this.searchOption.isOpenMore;
  }
  // 获取线下资源表格数据
  private getOfflineResTableData(currPage = 0) {
    this.page.currPage = currPage;
    OfflineResMgr.getOfflineResList(this.searchOption, this.page).then(res => {
      this.offlineResTableData = res.data;
      this.page.total = parseInt(res.headers.total, 10);
    });
  }
  // 表格选项发生变化
  private handleSelectionChange(data) {
    this.selectedTableDataIds = data.map(item => item.id).join(',');
  }
  // 表格分页条数Change
  private pageSizeChange(value) {
    this.page.size = value;
    this.getOfflineResTableData();
  }
  // 表格当前页Change
  private currentPageChange(value) {
    this.getOfflineResTableData(value);
  }
  // 删除线下资源
  private deleteResource(data) {
    this.$confirm('确定删除该资源？', '删除资源', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      OfflineResMgr.deleteResourceById(data.id).then(() => {
        this.getOfflineResTableData();
      });
    });
  }

  /********** 导入导出相关 **********/
  private fileList: object[] = []; // 导入文件列表
  private formData: object = {}; // 导入文件传参
  private headers: any = { authToken: getAuthToken() }; // token值
  private loadingScreen: any = {}; // 加载屏幕
  private uploadSuccessModalVisible: boolean = false; // 是否显示导入文件成功模态框
  // 导入结果
  private uploadResult: any = {
    status: ''
  };
  // 上传文件
  private fileBeforeUpload(file) {
    this.formData = { fileName: file.name };
    this.openLoadingScreen();
    return new Promise((resolve, reject) => {
      this.$nextTick(() => {
        resolve(true);
      });
    });
  }
  // 上传文件成功
  private fileSuccess(data) {
    // 关闭导入Loading
    this.loadingScreen.close();
    // 弹框
    this.uploadResult = {
      fileCode: data.fileCode,
      status:  data.status,
      data: data.importRes,
      columns: [
        { title: 'Sheet', prop: 'sheetName' },
        { title: '导入总数', prop: 'totalCount' },
        { title: '正确', prop: 'successCount'},
        { title: '错误', prop: 'failCount'},
        { title: '导入完成', prop: 'importCount'}
      ]
    };
    this.uploadSuccessModalVisible = true;
  }
  // 上传文件失败
  private fileOnError(data) {
    this.loadingScreen.close();
    const errorMsg = JSON.parse(data.message);
    this.$alert(errorMsg.msg, '导入文件失败', {
      showCancelButton: true,
      showConfirmButton: false,
      cancelButtonText: '关闭',
      type: 'warning'
    });
  }
  private openLoadingScreen() {
    this.loadingScreen = this.$loading({
      lock: true,
      text: '导入中, 请稍后',
      spinner: 'el-icon-loading',
      background: 'rgba(255, 255, 255, 0.7)'
    });
  }
}
